import { groupEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import React, { useEffect, useState } from 'react';
import styles from './UsersList.module.scss';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import Checkbox from 'component/atom/forms/checkbox/Checkbox';
import Button from 'component/atom/forms/button/Button';
import { usePost } from 'hooks/usePost';

const UsersList = ({ groupId }) => {
  const [searchValue, setSearchValue] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);

  const { mutate: addToGroup, isPending } = usePost();

  const { data: users, refetch } = useFetch(
    ['usersNotInGroup', groupId],
    groupEndpoints.getAllUsersInCompany,
    {
      enabled: !!groupId,
    },
    {
      userGroupId: groupId,
      searchBy: searchValue,
    },
  );

  const handleAddToGroup = () => {
    addToGroup(
      {
        url: groupEndpoints.assignToGroup,
        data: {
          userGroupId: groupId,
          userIds: selectedUsers,
        },
      },
      {
        onSuccess: () => {
          refetch();
        },
        onError: (error) => {
          console.error('Error creating folder:', error);
        },
      },
    );
  };

  useEffect(() => {
    if (searchValue) {
      refetch();
    }
  }, [searchValue]);

  const usersList = users?.data || [];

  const handleToggleUser = (userId, checked) => {
    setSelectedUsers((prev) =>
      checked ? [...prev, userId] : prev.filter((id) => id !== userId),
    );
  };

  return (
    <div className={styles['add-existing-container']}>
      <SearchInput
        value={searchValue}
        onChange={(name, e) => setSearchValue(e)}
        placeholder='Search by name'
      />

      <div className={styles['users-list-wrapper']}>
        <div className={styles['users-list-header']}>
          <p className={styles['users-header-title']}>Users</p>
          <p className={styles['users-header-title']}>Current Group</p>
        </div>

        <div className={styles['users-list-body']}>
          {usersList.map((user) => {
            const isSelected = selectedUsers.includes(user.userId);

            return (
              <div className={styles['user-row']} key={user.userId}>
                <div className={styles['user-left-side']}>
                  <Checkbox
                    name={`user-${user.userId}`}
                    ischecked={isSelected}
                    onChange={(checked) =>
                      handleToggleUser(user.userId, checked)
                    }
                    labelClassName={styles['user-checkbox-label']}
                    boxClassName={styles['user-checkbox-box']}
                  />

                  <div className={styles['image-placeholder']}>
                    <p>{user?.name?.charAt(0)}</p>
                  </div>

                  <div className={styles['user-details']}>
                    <p className={styles['user-name']}>{user.name}</p>
                    <p className={styles['user-email']}>{user.email}</p>
                  </div>
                </div>

                <div className={styles['user-group']}>
                  {user.groupName || '-'}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles['users-footer']}>
        <p className={styles['selected-users-text']}>
          {selectedUsers.length} user(s) selected
        </p>

        <Button
          label='Add to Group'
          type='plus'
          onClick={handleAddToGroup}
          isLoading={isPending}
        />
      </div>
    </div>
  );
};

export default UsersList;
